<template>
  <span :class="color + '--text ' + (center ? 'centered-text' : '') " class="subheading root">

    <v-tooltip v-if="hint" bottom>
      <v-icon v-if="icon" slot="activator" class="icon mr-3" :color="color">{{ icon }}</v-icon>
      <span>{{ hint }}</span>
    </v-tooltip>

    <v-icon v-else-if="icon" class="icon mr-3" :color="color">{{ icon }}</v-icon>

    <span class="text">
      <slot></slot>
    </span>
  </span>
</template>

<script>
export default {
    name: 'IconLabel',
    props: {
        icon: String,
        hint: String,
        color: String,
        center: Boolean
    }
}
</script>

<style scoped>
  .root {
    vertical-align: bottom;
  }

  .icon, .text {
    display: flex;
  }

  .icon {
    float: left;
  }

  .text {
    line-height: 24px;
  }

  .centered-text {
    line-height: 24px;
  }
</style>
